import { computed, type Ref, unref } from "vue";
import { useRoute, useRouter } from "vue-router";

export interface OwnerFilterOptions {
  owner?: string | null;
}

export function useOwnerFilter() {
  const route = useRoute();
  const router = useRouter();

  const owner = computed(() => {
    const ownerParam = route.query.owner;
    if (!ownerParam || ownerParam === "all") return null;
    if (ownerParam === "unassigned" || ownerParam === "null") return "unassigned";
    return ownerParam as string;
  });

  /**
   * Set owner filter in route query
   * @param value - "all", "unassigned", or user ID
   */
  const setOwner = (value: string | null) => {
    const query = { ...route.query };
    if (!value || value === "all") {
      delete query.owner;
    } else {
      query.owner = value;
    }
    router.push({ query });
  };

  /**
   * Convert route owner param to backend ownerId param
   * @returns null for unassigned, user ID string, or undefined for "all"
   */
  const getOwnerIdForBackend = (): string | null | undefined => {
    const ownerValue = owner.value;
    if (!ownerValue) return undefined; // "all" - no filter
    if (ownerValue === "unassigned") return null; // unassigned filter
    return ownerValue; // specific user ID
  };

  return {
    owner,
    setOwner,
    getOwnerIdForBackend,
  };
}
